import impersonationMixin from '@/mixins/impersonation';

/**
 * A visszaút-sáv. Az állapot az `users/authenticated` válaszából jön, nincs saját hívása.
 */
/** Az elrejtés a lapé és az éppen futó átjelentkezéshez kötött. */
const DISMISS_KEY = 'impersonation-bar-dismissed';
export default {
  name: 'ImpersonationBar',
  mixins: [impersonationMixin],
  data() {
    return {
      dismissedFor: this.readDismissed()
    };
  },
  computed: {
    barVisible() {
      return this.isImpersonating && this.dismissedFor !== this.dismissKey;
    },
    dismissKey() {
      return [this.impersonationUser?.id, this.impersonation?.impersonator?.id].join(':');
    },
    text() {
      return this.$t('users.impersonation.bar', {
        user: this.impersonationUser?.name || '',
        impersonator: this.impersonatorName
      }).ucFirst();
    }
  },
  watch: {
    // A fix sáv helyét a body térköze adja vissza, hogy a lábléc ne csússzon alá.
    barVisible: {
      immediate: true,
      handler(value) {
        document.body.classList.toggle('has-impersonation-bar', !!value);
      }
    }
  },
  beforeUnmount() {
    document.body.classList.remove('has-impersonation-bar');
  },
  methods: {
    readDismissed() {
      try {
        return window.sessionStorage.getItem(DISMISS_KEY);
      } catch (e) {
        return null;
      }
    },
    dismiss() {
      this.dismissedFor = this.dismissKey;
      try {
        window.sessionStorage.setItem(DISMISS_KEY, this.dismissKey);
      } catch (e) {
        // Az elrejtés ilyenkor csak eddig az oldalbetöltésig tart.
      }
    },
    restore() {
      this.dismissedFor = null;
      try {
        window.sessionStorage.removeItem(DISMISS_KEY);
      } catch (e) {
        // ld. fent
      }
    }
  }
};